import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = "查看更多" }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2.5">
          <span className="w-1.5 h-6 rounded-full bg-primary-500" />
          {title}
        </h2>
        {subtitle && <p className="text-sm text-foreground-600 mt-1.5">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}